import React from 'react';
import UI from '../ui';
import Util from '../utils/Util';
import { Section } from '../ui/layout/Section.component';

const { WrappedButton, WrappedButtonType, CollapsibleCard, InfoBanner } = UI;

export const CustomAuth0Error = ({ goToSignInView }) => {
	const error = Util.getQueryParamByName('error') || '';
	const errorMessage = Util.getQueryParamByName('error_description') || '';
	const trackingId = Util.getQueryParamByName('tracking') || '';

	const onClickReturnToLogin = () => {
		goToSignInView();
	};

	return (
		<div className="common-authentication auth0-custom-error-view">
			<div className="form">
				<div className="error-header">Something Went Wrong</div>
					<section className="generic-error-section">
						<div className="exclamation-icon" />
						<p className="generic-error-label">
							There could be a misconfiguration in the system or a service outage.
						</p>
						<p className='generic-error-content'>
							We track these errors automatically, but if the problem persists feel free to contact us. Please try again.
						</p>
					</section>
				{errorMessage && (
					<CollapsibleCard
						header="Technical Details"
						dataqa="auth0-error-view"
					>
						<div className="auth0-error-content">
							<p><span className='error-context'>{error}</span> : {errorMessage}</p>
							{trackingId && (
								<p className='tracking-id'>
									<span className='tracking-id-label'>TRACKING ID: </span>{trackingId}
								</p>
							)}
						</div>

					</CollapsibleCard>
				)}

				<div className="row-container centered">
					<WrappedButton
						label="Return to login"
						className="signin-primary-button"
						buttonType={WrappedButtonType.Primary}
						dataqa="return-to-login-error"
						onClick={onClickReturnToLogin}
					/>
				</div>
				<div className="contact-support">
					<p>
						For further assistance, contact customer support at 888-434-0055, Monday–Friday, 8am–8pm Central Time.
					</p>
				</div>
			</div>
		</div>
	);
};
